<div class="info-page">
  <h3>{{ actionLabel }} Análise</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Situação</label>
      <textarea id="description" class="form-control" rows="8" formControlName="description" placeholder="Descrição da Situação" maxlength="1000"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
  </div>

  <!-- Table -->
  <div class="form-group row m-b" *ngIf="entity?.extras?.length">
    <div class="col-12 col-sm-8">
      <label class="col-sm-12 pb-1">Medida Física</label>
      <div class="system-table table-container system-table-m-b table-form">
        <div class="system-table-conteiner system-table-form-conteiner">
          <table>
            <thead>
              <tr>
                <th>Título</th>
                <th>Unid. med.</th>
                <th>Meta</th>
                <th>Última Medição</th>
                <th>Medição Atual</th>
              </tr>
            </thead>
            <tbody formArrayName="extras">
              <tr *ngFor="let item of getFormArray().controls; let i = index" [formGroupName]="i">
                <td>{{item?.value?.title}}</td>
                <td>{{item?.value?.unit_id}}</td>
                <td>{{item?.value?.goal}}</td>
                <td>{{item?.value?.value_done_last_one}}</td>
                <td class="text-right">
                  <input type="text" class="form-control text-right" formControlName="done" (keyup)="formatarMedidaFisica(i)">
                  <app-field-message [field]="fieldMessageRequireds('done', i)" [erros]="fieldErrosFormArray('done', i)"></app-field-message>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>


  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<app-loading [loader]="isLoading"></app-loading>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>